import type { User } from '../types/api';

// Inbound email addresses are always hosted on instapaper.com.
const EMAIL_HOST = 'instapaper.com';

/**
 * The user's Instapaper inbound Kindle address (kindle.xxxxx@instapaper.com),
 * which they add to Amazon's Approved Personal Document E-mail List.
 * Returns undefined when not available on the session (e.g. logged out).
 */
export function getKindleEmail(user: User | undefined): string | undefined {
  return user?.kindleEmail || undefined;
}

/**
 * The user's Save to Instapaper address (readlater.<hash>@instapaper.com), or a
 * per-folder variant (readlater.<hash>+<folderId>@instapaper.com) when folderId
 * is provided. Mirrors the backend `User.generate_inbound_email`.
 * Returns undefined when the email hash key isn't available on the session.
 */
export function buildSaveEmail(
  user: User | undefined,
  folderId?: string,
): string | undefined {
  const hashKey = user?.emailHashKey;
  if (!hashKey) return undefined;

  const local = folderId ? `readlater.${hashKey}+${folderId}` : `readlater.${hashKey}`;
  return `${local}@${EMAIL_HOST}`;
}

export { EMAIL_HOST };
